export const REGISTRATION_URL = "https://app.asatta.org/alta-socio";
export const LOGIN_URL = "https://app.asatta.org/login";

export const LOGO_URL = "/assets/brand/logo-asatta.png";
export const LOGO_WHITE_URL = "/assets/brand/logo-asatta-white.png";

export const FEDERATION_LOGO_URL =
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_join-asatta/artifacts/bip01di1_image.png";

export const SITE = {
    name: "ASATTA",
    fullName: "Asociación de Alojamientos Turísticos de Tarifa",
    tagline: "Representamos y hacemos crecer los alojamientos turísticos de Tarifa.",
    quota: "15 € / mes",
    commitment:
        "Únete sin ataduras, pero con vocación. Pedimos a cada asociado un compromiso mínimo de un año para construir juntos una asociación fuerte.",
    email: "info@asatta.org",
    phone: null,
    address: "Batalla del Salado 36, 11380 Tarifa (Cádiz)",
};

export const LEGAL = {
    cif: "G72358849",
    updatedAt: "julio de 2026",
};
